import * as React from "react";
function XxlIcon() {
    return React.createElement("path", { d: "M7 43.0002V8.26953H13.577V4.76953H16.0962V8.26953H31.9807V4.76953H34.4422V8.26953H40.9999V43.0002H7ZM9.2692 40.731H38.7307V20.2503H9.2692V40.731ZM9.2692 17.9811H38.7307V10.5387H9.2692V17.9811Z", fill: "currentColor" });
}
export default XxlIcon;
//# sourceMappingURL=Xxl.js.map